"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var RadioGroupService = (function () {
    function RadioGroupService() {
        this.optionSelectedSource = new Subject_1.Subject();
    }
    RadioGroupService.prototype.announceSelectedOption = function (value) {
        this.optionSelectedSource.next(value);
    };
    Object.defineProperty(RadioGroupService.prototype, "optionSelected$", {
        get: function () {
            return this.optionSelectedSource.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    return RadioGroupService;
}());
RadioGroupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], RadioGroupService);
exports.RadioGroupService = RadioGroupService;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/radio/radio-group.service.js
// module id = 61
// module chunks = 0